import Vue, { CreateElement, VNode } from 'vue';
import { PaginationProps, PaginationListeners } from '@/types';

export default Vue.component('pagination', {
  functional: true,
  render(createElement: CreateElement, { props, listeners }): VNode {
    return createElement('div', {
      class: 'pagination',
    }, [
      createElement('div', {
        class: 'pagination-wrapper',
      },
        [...Array((props as PaginationProps).pages)].map((_, index) => {
          return createElement('span', {
            class: {
              'pagination-dots': true,
              'active': index === (props as PaginationProps).active,
            },
            style: {
              cursor: (props as PaginationProps).clicked && 'pointer',
            },
            on: {
              click: () => (props as PaginationProps).clicked && (listeners as PaginationListeners).click(index),
            },
          });
        }),
      ),
    ]);
  },
});
